<template>
  <div class="component title" :data-orientation="orientation" data-viewport>
    <div
      class="title__content"
      ref="title"
      data-medusa-animation="title"
      @click="openContacts"
      v-html="data.content.title"
    ></div>

    <div class="title__smalltext" v-if="data.content.smalltext" v-html="data.content.smalltext"></div>
  </div>
</template>

<script>
import { SplitText } from '@/scripts/libs/SplitText';

export default {
  name: 'TitleBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => '',
    },
    orientation: {
      type: String,
      required: false,
      default: 'left',
    },
  },

  data() {
    return {
      WebGLTitle: null,
      split: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.split = new SplitText(this.$refs.title, {
        charsClass: 'title__char',
        linesClass: 'title__line',
      });
    });
  },

  methods: {
    openContacts() {
      if (this.orientation === 'huge') {
        this.$store.commit('SET_CONTACT', true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  &__content {
    padding: $vertical-padding 0;
    font-size: rem(120px);
    font-size: calc(120px * var(--rw));
    line-height: rem(120px);
    line-height: calc(120px * var(--rw));

    @include mq($until: ipadL) {
      padding: $mobile-vertical-padding $mobile-horizontal-padding;
      font-size: rem(50px);
      font-size: calc(50px * var(--rw));
      line-height: rem(50px);
      line-height: calc(50px * var(--rw));
    }
  }

  &__smalltext {
    position: relative;
    bottom: calc((100vh / 18) * 1.5);
    padding-left: $extra-horizontal-padding;

    @include mq($until: ipadL) {
      bottom: calc((100vh / 18) * 0.5);
    }
  }

  &[data-orientation="left"] .title__content {
    padding-left: $extra-horizontal-padding;
    width: calc((100vw / 32) * 28);

    text-align: left;

    @include mq($until: ipadL) {
      padding-left: $extra-mobile-horizontal-padding;
    }
  }

  &[data-orientation="center"] .title__content {
    text-align: center;

    &-actual {
      font-size: rem(180px);
      font-size: calc(180px * var(--rw));
      line-height: rem(180px);
      line-height: calc(180px * var(--rw));

      @include mq($until: ipadL) {
        font-size: rem(100px);
        font-size: calc(100px * var(--rw));
        line-height: rem(100px);
        line-height: calc(100px * var(--rw));
      }
    }
  }

  &[data-orientation="right"] .title__content {
    padding-left: $extra-horizontal-padding;
    width: calc((100vw / 32) * 28);

    text-align: right;

    @include mq($until: ipadL) {
      padding-left: $extra-mobile-horizontal-padding;
    }
  }

  &[data-orientation="huge"] .title__content {
    font-size: rem(360px);
    font-size: calc(360px * var(--rw));
    line-height: rem(360px);
    line-height: calc(360px * var(--rw));
    text-align: center;
    cursor: pointer;

    @include mq($until: ipadL) {
      padding: $extra-mobile-vertical-padding 0;
      font-size: rem(120px);
      font-size: calc(120px * var(--rw));
      line-height: rem(120px);
      line-height: calc(120px * var(--rw));
    }
  }
}
</style>
<style lang="scss">
.title {
  &__line,
  &__char {
    -webkit-clip-path: inset(0 0 0 0);
    clip-path: inset(0 0 0 0);
  }
}
</style>
